import { Text } from '@components/v2/ui';
import { Box, Flex } from '@mantine/core';

export const WarningAlert = ({
	description,
}: {
	description: string;
}) => (
	<Box
		style={{
			padding: '14px 24px',
			borderRadius: '20px',
		}}
		bg="#F0F3F8"
		w={'100%'}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="42"
			height="42"
			viewBox="0 0 42 42"
			fill="none"
		>
			<path
				d="M20.9998 15.3125V22.3125M17.9914 6.37207L4.89445 28.3988C3.50723 30.7318 5.18852 33.6875 7.90282 33.6875H34.0967C36.811 33.6875 38.4923 30.7318 37.1051 28.3988L24.0082 6.37206C22.6515 4.09041 19.3481 4.09042 17.9914 6.37207Z"
				stroke="#97AAC1"
				stroke-width="1.5"
				stroke-linecap="round"
			/>
			<circle
				cx="21"
				cy="27.125"
				r="1.75"
				fill="#97AAC1"
			/>
		</svg>
		<Flex align="flex-start" gap="md">
			<Text c="#43516A" variant="body2">
				{description}
			</Text>
		</Flex>
	</Box>
);
